export default "__VITE_ASSET__4687a322__"